import { useQueryClient as e } from "@maat/store-hooks";
import { authQueryKeys as t } from "@maat/store-auth";
import { useCallback as n } from "react";
//#region src/verification/useRefreshIdentityBookingGate.ts
var r = () => {
	let r = e();
	return n(() => {
		r.invalidateQueries({ queryKey: t.me() });
	}, [r]);
};
//#endregion
export { r as useRefreshIdentityBookingGate };
